import {
    doesStringHaveSpecialChars, isNumeric, isEmailAddressValid, 
    isPostalCodeValid, isPhoneValid, containsAlphaNumAndSpaceOnly,validAddress,
    isNotXssChars
} from "../../util/Validators";

// let newPass= '';

export const validateInput = (name, value, formData) => {
    let hasError = false,
        error = "";
    switch (name) {
        case "accountTypeId":
            if (value.trim() === "") {
                hasError = true;
                error = "Account Type cannot be empty";
            } else {
                hasError = false;
                error = "";
            }
            break;

        case "address":
            if (value.trim() === "") {
                hasError = true;
                error = "Address cannot be empty";
            } else if (!validAddress(value)) {
                hasError = true
                error = "Invalid Address. Only alphabets are allowed";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "city":
            if (value.trim() === "") {
                hasError = true;
                error = "City cannot be empty";
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid City. Only alphabets are allowed";
            }
            else if (doesStringHaveSpecialChars(value)) {
                hasError = true
                error = "Invalid City. Avoid Special characters"
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "state":
            if (value.trim() === "") {
                hasError = true;
                error = "State cannot be empty";
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid State. Only alphabets are allowed";
            }
            else if (doesStringHaveSpecialChars(value)) {
                hasError = true
                error = "Invalid State. Avoid Special characters"
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "zip":
            if (value.trim() === "") {
                hasError = true;
                error = "Zip cannot be empty";
            } else if (!isPostalCodeValid(value.trim(), formData.country)) {
                hasError = true;
                error = "Not a valid postal code";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "country":
            if (value.trim() === "") {
                hasError = true;
                error = "Country cannot be empty";
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid Country. Only alphabets are allowed";
            }
            else if (doesStringHaveSpecialChars(value)) {
                hasError = true
                error = "Invalid Country. Avoid Special characters"
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "firstName":
            if (value.trim() === "") {
                hasError = true
                error = "First name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid First Name. Only alphabets are allowed";
            }
            else if (doesStringHaveSpecialChars(value)) {
                hasError = true
                error = "Invalid First Name. Avoid Special characters"
            } else {
                hasError = false
                error = ""
            }
            break;
        case "lastName":
            if (value.trim() === "") {
                hasError = true
                error = "Last name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Invalid Last Name. Only alphabets are allowed";
            } else if (doesStringHaveSpecialChars(value)) {
                hasError = true
                error = "Invalid Last Name. Avoid Special characters"
            } else {
                hasError = false
                error = ""
            }
            break;
        case "companyName":
            if (value.trim() === "") {
                hasError = false
                error = ""
            } else if (!isNotXssChars(value)) {
                hasError = true
                error = "Invalid Company Name. Avoid Special characters"
            } else {
                hasError = false
                error = ""
            }
            break;            
        case "email":
            if (value.trim() === "") {
                hasError = true
                error = "Email cannot be empty"
            } else if (!isEmailAddressValid(value)) {
                hasError = true
                error = "Invalid Email"
            } else {
                hasError = false
                error = ""
            }
            break;
        case "mobilePhoneNumber":
            if (value.trim() === "") {
                hasError = true
                error = "Mobile cannot be empty"
            } else if (!isPhoneValid(value)) {
                hasError = true
                error = "Invalid Mobile Number. Use 10 digits only"
            } else {
                hasError = false
                error = ""
            }
            break
        case "recurringBilling":
            if (value == null || (value !== 'true' && value !== 'false')) {
                hasError = true;
                error = "Recurring Billing cannot be empty";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "recurringBillDom":
            if (value && !isNumeric(value)) {
                hasError = true;
                error = "Recurring Bill Day of Month must be numeric";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "recurringAmount":
            if (value && !isNumeric(value)) {
                hasError = true;
                error = "Recurring Amount must be numeric";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "billDueDays":
            if (value && !isNumeric(value)) {
                hasError = true;
                error = "Bill Due Days must be numeric";
            } else {
                hasError = false;
                error = "";
            }
            break;            

        default:
            break
    }
    return { hasError, error }
}